import { Box, Stack, Tooltip, SxProps, Theme } from '@evaneos/b2b-ui';
import { useIntl } from 'react-intl';

import { CircledStar } from '../Icons/CircledStar';

type RepeaterBadgeProps = {
    size?: number;
    noMargin?: boolean;
    displayTooltip?: boolean;
    sx?: SxProps<Theme>;
};

export const RepeaterBadge = ({
    size = 24,
    noMargin = false,
    displayTooltip = true,
    sx,
}: RepeaterBadgeProps) => {
    const { formatMessage } = useIntl();
    return (
        <Stack
            sx={{
                mx: noMargin ? 0 : 1,
                alignItems: 'center',
                justifyContent: 'center',
                ...sx,
            }}
            data-testid="repeater-badge"
        >
            <Tooltip
                title={
                    displayTooltip
                        ? formatMessage({
                              id: 'dossier.repeater_tooltip',
                          })
                        : ''
                }
                placement={'top'}
                arrow
            >
                <Box display="flex" alignItems="center">
                    <CircledStar
                        color={'var(--gold)'}
                        size={size}
                        data-tip
                        data-for="repeater-badge"
                    />
                </Box>
            </Tooltip>
        </Stack>
    );
};
